import api from '../..'

const destroyCourse = (courseId: number) => {
  return api.delete(`administration/courses/${courseId}`)
}

export default destroyCourse
